import { apiClient } from "@/lib/api-client";

export type UnsurPembimbingAkademikData = Record<string, any>;

export type UnsurPembimbingAkademikResponse = {
  datas: UnsurPembimbingAkademikData;
  message: string;
};

export const fetchUnsurPembimbingAkademik = async ({
  niu,
  year,
  semester,
  periodeID,
}: {
  niu: string;
  year: number;
  semester: number;
  periodeID?: number | null;
}): Promise<UnsurPembimbingAkademikData> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    ...(periodeID && { periodeID: periodeID.toString() }),
  });

  const resData = await apiClient<UnsurPembimbingAkademikResponse>(
    `${baseUrl}/api/v1/unsur-pembimbing-akademik/${niu}?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return resData.datas;
};
